import util from '@bmp-vue/core/api/util'
const controller = 'Empresa'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetAllByUsuario: function (email) {
    const ambiente = window.env.VUE_APP_AMBIENTE === 'default' ? null : window.env.VUE_APP_AMBIENTE
    const dto = { parameters: [{ name: 'email', value: email }, { name: 'ambiente', value: ambiente }] }
    return util.Axios.GetAll(controller + '/GetAllByUsuario', dto)
  },
  GetCustomJSON: function (codigo) {
    return util.Axios.Get(controller + '/GetCustomJSON', codigo)
  },
  GetByAmbiente: function () {
    return util.Axios.Get(controller + '/GetByAmbiente', window.env.VUE_APP_AMBIENTE)
  },
  GetByIdToParceiro: function (codigo) {
    return util.Axios.Get(controller + '/GetByIdToParceiro', codigo)
  }
})
